import type { ReactNode } from 'react';

import type { LANGUAGE } from '@/types/commonConst';

import { getFeatureMessage } from '..';
import { scrapingMessages } from './messages';

export type ScrapingMessageKey = keyof typeof scrapingMessages;

export const getScrapingMessage = (
  lang: LANGUAGE,
  key: ScrapingMessageKey,
  params?: Record<string, string | number>,
): ReactNode => {
  return getFeatureMessage(scrapingMessages[key], lang, params);
};
